import { gql } from "@apollo/client";

export const PROJECT_QUERY = gql`
  query Project($projectId: ID!) {
    project(projectId: $projectId) {
      id
      name
      identifier
      enableGraphV2
      secret
      allowOrigins
      apiToken
      createdAt
    }
  }
`;

export const PROJECTS_SIMPLIFIED_QUERY = gql`
  query Projects {
    projects {
      id
      name
      identifier
      enableGraphV2
      apiToken
      createdAt
    }
  }
`;

export const PROJECT_LIST_QUERY = gql`
  query Projects {
    projects {
      label: name
      value: id
    }
  }
`;

export const PROJECTS_QUERY = gql`
  query Projects {
    projects {
      id
      name
      identifier
      enableGraphV2
      createdAt
      subgraphsCount
      mainnetEndpointActive
      mainnetArchiveEndpointActive
      testnetEndpointActive
      testnetArchiveEndpointActive
    }
  }
`;

export const CREATE_PROJECT_MUTATION = gql`
  mutation CreateProject($identifier: String!, $name: String!) {
    createProject(identifier: $identifier, name: $name) {
      id
    }
  }
`;

export const UPDATE_PROJECT_MUTATION = gql`
  mutation UpdateProject($id: ID!, $name: String) {
    updateProject(projectId: $id, name: $name) {
      id
      name
    }
  }
`;

export const UPDATE_PROJECT_CORS_MUTATION = gql`
  mutation updateProjectCors($id: ID!, $allowOrigins: [String!]) {
    updateProjectCors(projectId: $id, allowOrigins: $allowOrigins) {
      id
      name
      allowOrigins
    }
  }
`;

export const DELETE_PROJECT_MUTATION = gql`
  mutation DeleteProject($projectId: ID!) {
    deleteProject(projectId: $projectId) {
      createdAt
      id
      identifier
      name
      secret
    }
  }
`;

export const GENERATE_PROJECT_API_TOKEN_MUTATION = gql`
  mutation GenerateProjectAPIToken($projectId: ID!) {
    generateProjectAPIToken(projectId: $projectId) {
      apiToken
      id
      identifier
      name
    }
  }
`;

export const GENERATE_PROJECT_SECRET = gql`
  mutation GenerateProjectSecret($projectId: ID!) {
    generateProjectSecret(projectId: $projectId) {
      createdAt
      id
      identifier
      secret
    }
  }
`;
